document.addEventListener("DOMContentLoaded", function () {
  const titleEl = document.querySelector("[data-product-title]");
  if (!titleEl) return;

  const baseTitle = titleEl.dataset.baseTitle;
  if (!baseTitle) return;

  let optionIndex = 0;
  const optionGroups = document.querySelectorAll("[data-option-position]");

  optionGroups.forEach((el) => {
    const label = el.querySelector("legend, .variant-picker__label");
    if (!label) return;

    const text = label.textContent.toLowerCase();
    if (
      text.includes("color") ||
      text.includes("design") ||
      text.includes("theme")
    ) {
      optionIndex = parseInt(el.dataset.optionPosition, 10) - 1;
    }
  });

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    const selectedValue = variant.options?.[optionIndex];
    if (!selectedValue) return;

    titleEl.textContent = `${baseTitle} – ${selectedValue}`;
  });
});
